import { useEffect, useState } from 'react';
import { navigate } from '../app/router.ts';
import { CoverTile } from './CoverTile.tsx';
import { useGroups, useProgressMap } from './hooks.ts';
import { useLongPress } from './useLongPress.ts';
import { getItem } from '../data/catalog.ts';
import { progressFraction } from '../data/progress.ts';
import type { CatalogItem, ProgressEntry } from '../data/db.ts';

/**
 * Startseite fuer das Kind: oben die zuletzt angefangene Folge zum
 * Weiterhoeren, darunter ein Bild pro Gruppe.
 */
export function HomeScreen() {
  const { groups } = useGroups();
  const progressMap = useProgressMap(groups.length);
  const [resume, setResume] = useState<{ item: CatalogItem; entry: ProgressEntry } | null>(null);

  const adminHandlers = useLongPress(() => navigate('/eltern'));

  // Zuletzt angefangene, noch nicht beendete Folge suchen.
  useEffect(() => {
    const candidates = [...progressMap.values()]
      .filter((entry) => entry.state === 'inProgress')
      .sort((a, b) => b.lastPlayedAt - a.lastPlayedAt);

    let cancelled = false;

    void (async () => {
      // Der Reihe nach pruefen: die zuletzt gehoerte Folge kann inzwischen aus
      // dem Katalog entfernt worden sein, dann gilt die naechstaeltere.
      for (const entry of candidates) {
        const item = await getItem(entry.itemId);
        if (cancelled) return;
        if (item) {
          setResume({ item, entry });
          return;
        }
      }
      if (!cancelled) setResume(null);
    })();

    return () => {
      cancelled = true;
    };
  }, [progressMap]);

  return (
    <div className="kids">
      <header className="kids__bar kids__bar--right">        {/* Langes Draufhalten oeffnet den Elternbereich. Bewusst oben rechts,
            damit es nicht mit dem Haus-Symbol der anderen Screens kollidiert. */}
        <span className="kids__logo" {...adminHandlers} aria-hidden="true">
          ♪
        </span>
      </header>

      {resume && (
        <section className="resume">
          <CoverTile
            title={resume.item.title}
            imageUrl={resume.item.imageUrl}
            size="large"
            state="inProgress"
            fraction={progressFraction(
              resume.entry.trackIndex,
              resume.entry.positionMs,
              null,
              resume.entry.trackCount,
            )}
            onClick={() => navigate(`/spielt/${resume.item.id}`)}
          />
        </section>
      )}

      {groups.length === 0 ? (
        <p className="kids__empty">
          <span aria-hidden="true">♪</span>
        </p>
      ) : (
        <section className="grid">
          {groups.map((group) => (
            <CoverTile
              key={group.id}
              title={group.title}
              imageUrl={group.imageUrl}
              onClick={() => navigate(`/gruppe/${group.id}`)}
            />
          ))}
        </section>
      )}
    </div>
  );
}
